import { Component, Input, computed, inject, input, output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router, RouterLink } from '@angular/router';
import { ModalContentData } from '../modal-content';
import { SignalsStoreService } from '../../signals-store.service';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-welcome-message',
    imports: [RouterLink],
    templateUrl: './welcome-message.component.html',
    styleUrl: './welcome-message.component.scss'
})
export class WelcomeMessageComponent {

  private signalsStoreService = inject(SignalsStoreService);

  isLimitedUser = computed(() => this.signalsStoreService.isLimitedUser());

  activeModal = inject(NgbActiveModal);
  router = inject(Router);

  @Input() modalContentData!: ModalContentData;

  /** True when the step is hosted by the signup onboarding modal (DEV-10703). */
  embedded = input(false);
  /** True when another step follows, so the button invites instead of closing. */
  hasNextStep = input(false);
  /** First-login copy for accounts that have one; replaces the default message, never the delivery card. */
  customMessage = input('');
  /** Emitted instead of closing, so the host can move on to the next step. */
  completed = output<void>();

  buttonLabel = computed(() => {
    if (this.isLimitedUser()) return 'Customize box';
    return this.hasNextStep() ? 'Continue' : 'Ok, I got it!';
  });

  goTo() {
    let route = 'shop';
    if (this.isLimitedUser()) {
      // Get the default view to redirect:
      const defaultRoute = environment.config.flows.specialMembership.defaultRoute;
      route = defaultRoute || route;
    }
    this.router.navigate([`/${route}`]);
    // When embedded, the modal stays open on top of the route we just navigated to:
    // the customer still has the checkout disclaimer step to read.
    if (this.embedded()) return this.completed.emit();
    this.close();
  }

  close() {
    this.activeModal.close();
  }
}
